// extracted by mini-css-extract-plugin
export var cardContainer = "_rq-0";
export var cardHeader = "_rq-2";
export var collapsedState = "_rq-3";
export var dragHandle = "_rq-5";
export var dragHandleIcon = "_rq-6";
export var dragging = "_rq-1";
export var titleArea = "_rq-4";